"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var LOADING_MESSAGES = [
    "Czuwanie...",
    "Tworzenie lepszego świata...",
    "Odpytywanie harcerzy...",
    "Angażowanie hufców...",
    "Angażowanie chorągwi...",
    "Angażowanie Głównej Kwatery...",
    "Refowanie bukszprytu...",
    "Deklinacja nazwisk...",
    "Przekazywanie rozkazów...",
    "Miłowanie przyrody...",
    "Mobilizowanie jednostek...",
    "Strzyżenie lam...",
    "Delegowanie zadań...",
    "Abstrahowanie od tematu...",
    "Pisanie rozkazu...",
    "Pracowanie z kadrą...",
    "Wychowywanie młodego człowieka...",
    "Dłubanie medalu z ziemniaka..."
];
exports.default = vue_1.default.extend({
    name: "the-loading",
    data: function () {
        return {
            timeToNextMessage: 1250,
            nextMessageTimeout: 0,
            loadingMessage: this.getInitialLoadingMessage()
        };
    },
    computed: {
        show: function () {
            return this.$store.state.isLoading;
        }
    },
    watch: {
        show: function (newValue, oldValue) {
            if (newValue && !oldValue) {
                this.setTimeout();
            }
            else if (!newValue && oldValue) {
                this.clearTimeout();
            }
        }
    },
    beforeDestroy: function () {
        this.clearTimeout();
    },
    methods: {
        getInitialLoadingMessage: function () {
            return this.$lang("Wczytywanie...");
        },
        nextLoadingMessage: function () {
            this.loadingMessage = this.getRandomMessage();
            this.setTimeout();
        },
        getRandomMessage: function () {
            return LOADING_MESSAGES[Math.random() * LOADING_MESSAGES.length | 0];
        },
        setTimeout: function () {
            var _this = this;
            this.nextMessageTimeout = window.setTimeout(function () {
                _this.nextLoadingMessage();
            }, this.timeToNextMessage);
        },
        clearTimeout: function () {
            clearTimeout(this.nextMessageTimeout);
            this.loadingMessage = this.getInitialLoadingMessage();
        }
    }
});
